import { CodecModule } from 'app/interfaces/CodecModule';
import React from 'react';

const CodecModuleContext = React.createContext<CodecModule>(undefined);

export default CodecModuleContext;
